import { useHistory } from "@/app/hooks/useHistory";
import React from "react";
import { useLocation, useNavigate, useParams } from "react-router";

export interface WithRouterProps {
  location: ReturnType<typeof useLocation>;
  navigate: ReturnType<typeof useNavigate>;
  params: ReturnType<typeof useParams>;
}

export function withRouter<P extends object>(Component: React.ComponentType<P & WithRouterProps>) {
  return (props: P) => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const history = useHistory();

    return <Component {...props} location={location} navigate={navigate} params={params} history={history} />;
  };
}
